'use client';
import ProductBanner from '@components/ProductBanner';
import Product from '@models/product';
import ProductHeadingPrimitive, {
  ProductHeadingProps as PrimitiveProps,
} from '@repo/ui/src/components/ProductHeading';
import RatingStars from '@repo/ui/src/components/RatingStars';
import React from 'react';
import { useProductContext } from '@context/ProductProvider';
import ProductPrice from '@repo/ui/src/components/Product/Price';
import { useVipAccess } from '@hooks/customer';

export interface ProductHeadingProps extends Omit<
  PrimitiveProps,
  'product' | 'banner' | 'rating' | 'price'
> {
  product?: Product;
  showPrice?: boolean;
}

const ProductHeading = (props: ProductHeadingProps) => {
  const { vip } = useVipAccess();
  const { mainProduct: product } = useProductContext();

  if (!product) return null;

  const { showPrice, ...primitiveProps } = props;
  const canShowPrice = showPrice && !product.purchasing.hideCTA;

  const rating = product.ratingSummary ? (
    <RatingStars
      value={product.ratingSummary.average}
      hideValue
      reviewCount={product.ratingSummary.count}
      dark={props.dark}
    />
  ) : undefined;

  const price = canShowPrice ? (
    <ProductPrice
      product={product}
      component="h3"
      className="tra-text-web-heading-4 justify-center md:justify-start"
      vip={vip}
    />
  ) : undefined;

  return (
    <ProductHeadingPrimitive
      {...primitiveProps}
      product={product}
      banner={<ProductBanner product={product} />}
      rating={rating}
      price={price}
    />
  );
};

export default ProductHeading;
